import React, { useState, useEffect } from "react";
import {
  Toolbar,
  Box,
  Menu,
  MenuItem,
  Alert,
  Snackbar,
  PaginationItem,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AssignmentIcon from "@mui/icons-material/Assignment";
import AddConsumptionByFacility from "./AddConsumptionByFacility";
import ViewConsumptionByFacility from "./ViewConsumptionByFacility";
import FilterDrawer from "../../../Components/Masters/FilterDrawer";
import TopMenu from "../../../Components/Masters/TopMenu";
import { get, api, del } from "../../../utils/api";
import DateRangePickerComponent from "../../Masters/Roles and Permissions/Filters/Date";
import MultiSelect from "../../Masters/Roles and Permissions/Filters/MultiSelect";
import Range from "../../Masters/Roles and Permissions/Filters/Range";
import Cards from "../../../Components/Common/Cards";
import ViewTable from "../../../Components/Common/ViewTable";
import DeleteDialog from "../../../Components/Masters/DeleteDialog";
import PaginationBox from "../../../Components/Masters/Pagination";
import { styled } from "@mui/material/styles";
import MonthYearFilter from "../../Masters/Roles and Permissions/Filters/MonthYearFilter";
import TopMenuUpload from "../../../Components/Masters/TopMenuUpload";
import BulkUploadModal from "../../../Components/Common/BulkUploadModal";
import { formatNumber } from "../../../utils/formatNumber";
import { formatNumberCommaSeparated } from "../../../utils/common";
import BulkUpload from "../BulkUpload";
import { useUser } from "../../../context/AuthContext";
import DeleteAlertDialog from "../../../Components/Masters/DeleteAlertDialog";

const ElectricityConsumption = () => {
  const { user } = useUser();
  const StyledPaginationItem = styled(PaginationItem)(({ theme }) => ({
    "&.Mui-selected": {
      backgroundColor: "green",
      color: "#fff",
      fontWeight: "bold",
    },
    "&:hover": {
      backgroundColor: "#ededed",
    },
  }));
  const [petroleums, setPetroleums] = useState([]);
  const [sortConfig, setSortConfig] = useState({
    key: "createdAt",
    direction: "desc",
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const [page, setPage] = useState(1);
  const [quantityRange, setQuantityRange] = useState({ min: "", max: "" });
  const [totalPages, setTotalPages] = useState(1);
  const [addData, setAddData] = useState(false);
  const [dataforView, setdataForView] = useState(null);
  const [uniqueValues, setUniqueValues] = useState({});
  const [selectedFields, setSelectedFields] = useState({
    equipment: [],
  });
  const [appliedFilters, setAppliedFilters] = useState({
    date: false,
    equipment: false,
    industrialEquipment: false,
    hoursUsed: false,
  });
  const [isFiltersApplied, setIsFiltersApplied] = useState(false);
  const [view, setView] = useState(false);
  const [dataView, setdataView] = useState(null);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [tableData, setTableData] = useState([]);
  // const [limit] = useState(10); // Number of items per page
  const [selectedFilter, setSelectedFilter] = useState("Date");
  const [drawerFilterOpen, setDrawerFilterOpen] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [endDate, setEndDate] = useState(null);
  const [startMonth, setStartMonth] = useState(null);
  const [endMonth, setEndMonth] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  // const [selectedDate, setSelectedDate] = useState(dayjs());
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [selectedPeriod, setSelectedPeriod] = React.useState("July");
  const [previousMeterReading, setPreviousMeterReading] = useState({
    min: "",
    max: "",
  });
  const [currentMeterReading, setCurrentMeterReading] = useState({
    min: "",
    max: "",
  });
  const [unitOfConsumption, setUnitOfConsumption] = useState({
    min: "",
    max: "",
  });
  const [errors, setErrors] = useState({
    Date: false,
    consumptionMonth: false,
    equipmentType: false,
    industrialEquipment: false,
    hoursUsed: false,
  });
  const [hoursRange, setHoursRange] = useState({ min: "", max: "" });

  const [tempFilter, setTempFilter] = useState({
    startDate: null,
    endDate: null,
    startMonth: null,
    endMonth: null,
    equipment: [],
    unitOfConsumption: { min: "", max: "" },
    currentMeterReading: { min: "", max: "" },
    previousMeterReading: { min: "", max: "" },
  });
  const [cardData, setCardData] = useState({});
  const [filter, setFilters] = useState({});
  const [equipmentData, setEquipmentData] = useState([]);
  const [vendorData, setVendorData] = useState([]);
  const [bulkUploadModal, setBulkUploadModal] = useState(false);
  const [excelData, setExcelData] = useState(null);
  const [bulkUploadTable, setBulkUploadTable] = useState(true);
  const [formDataBulkUpload, setFormDataBulkUpload] = useState({});
  const [formData, setFormData] = useState({});
  const [matchData, setMatchData] = useState([]);
  const [jsonBulkUpload, setJsonBulkUpload] = useState([]);

  const fetchExcelData = async () => {
    await get("/scope2/consumptionByFacility/electricity/equipment")
      .then((res) => {
        let data = res.data;
        let arr = [];
        data.vendorData.forEach((v, vIdx) => {
          data.equipmentData.forEach((e, eIdx) => {
            arr.push({
              "Vendor Name": v.VendorLegalFullName,
              Equipment: e.equipment,
              "Month (in 01/25 or Jan-25)": "",
              "Previous Meter Reading": "",
              "Current Meter Reading": "",
              "Multiplying Factor": "",
              "Remark (optional)": "",
            });
          });
        });
        setExcelData(arr);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const equipmentList = async () => {
    const response = await get(`/master/Electricity/getEquipment`);
    setEquipmentData(response.data.data.map((item) => item.equipment));
    return response.data.data.map((item) => item.equipment);
  };
  const vendorList = async () => {
    const response = await get(`/master/Electricity/getAllVendor`);
    setVendorData(response.data.data.map((item) => item.VendorLegalFullName));
    return response.data.data.map((item) => item.VendorLegalFullName);
  };
  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        const [equipment, vendors] = await Promise.all([
          equipmentList(),
          vendorList(),
        ]);

   
        // Optionally store them in state

        // Now fetch your excel data
        fetchExcelData();
      } catch (error) {
        console.error("Error fetching equipment or vendors:", error);
      }
    };

    fetchInitialData();
  }, []);

  const headers = [
    { key: "createdAt", label: "Date", sortable: true, width: "12%" },
    {
      key: "consumptionPeriod",
      label: "Consumption Month",
      sortable: true,
      width: "15%",
    },
    {
      key: "previousMeterReading",
      label: "Previous meter reading",
      sortable: true,
      truncate: true,
      width: "12%",
    },
    {
      key: "currentMeterReading",
      label: "Current meter reading",
      sortable: true,
      truncate: true,
      width: "12%",
    },
    {
      key: "unitOfElectricityConsumption",
      label: "Units Consumed (KWH)",
      sortable: true,
      truncate: true,
      width: "15%",
    },
    {
      key: "vendor",
      label: "Vendor Name",
      sortable: true,
      width: "24%",
    },
  ];

  const inputData = [
    {
      fieldName: "consumptionPeriod",
      title: "Consumption Month",
      required: true,
      type: "date",
    },
    {
      fieldName: "vendor",
      title: "Vendor Name",
      placeholder: "Tap to select",
      type: "select",
      url: `${api}/master/Electricity/getAllVendor`,
      required: true,
      field: "VendorLegalFullName",
    },
    {
      fieldName: "previousMeterReading",
      title: "Previous Meter Reading",
      placeholder: "Enter previous meter reading",
      type: "number",
      required: true,
    },
    {
      fieldName: "currentMeterReading",
      title: "Current Meter  Reading",
      placeholder: "Enter current meter reading",
      type: "number",
      required: true,
    },
    {
      fieldName: "multiplicationFactor",
      title: "Multiplying Factor",
      placeholder: "Multiplying Factor",
      type: "number",
      required: true,
    },
    {
      fieldName: "unitOfElectricityConsumption",
      title: "Units Consumed",
      placeholder: "Autofilled",
      type: "number",
    },
    {
      fieldName: "equipment",
      title: "Equipment (optional)",
      placeholder: "Tap to Select",
      type: "multiselect",
      url: `${api}/master/Electricity/getEquipment`,
      field: "equipment",
      required: false,
    },

    {
      fieldName: "reasonForDeviation",
      title: "Reason For Deviation (optional)",
      placeholder: "Enter Reason",
      type: "text",
    },
    // {
    //   fieldName: "calorificValue.unit",
    // //   title: "Calorific Value Unit",
    //   placeholder: "Select unit",
    //   type: "select",
    //   options: ["MJ/kg", "MJ/m3"],
    //   required: true,
    // },
    {
      fieldName: "remarks",
      title: "Remark (optional)",
      placeholder: "Additional remarks",
      type: "text",
    },
    {
      fieldName: "editRemarkReason",
      title: "Edit Remark Reason",
      placeholder: "Additional edit remarks",
      type: "text",
      condition: true,
    },
    {
      fieldName: "documents",
      title: "Upload Documents (optional)",
      type: "file",
    },
  ];

  const filters = [
    "Date",
    "Consumption Month",
    "Previous Reading",
    "Current Reading",
    "Units Consumed (KWH)",
    // "Equipment",
  ];

  // Function to render the selected filter component based on user's choice

  const handlePeriodChange = (event) => {
    setSelectedPeriod(event.target.value);
  };

  const renderSelectedFilter = () => {
    switch (selectedFilter) {
      case "Date":
        return (
          <DateRangePickerComponent
            startDate={tempFilter?.startDate}
            endDate={tempFilter?.endDate}
            setStartDate={(date) =>
              setTempFilter((prev) => ({ ...prev, startDate: date }))
            }
            setEndDate={(date) =>
              setTempFilter((prev) => ({ ...prev, endDate: date }))
            }
            setErrors={setErrors}
            errors={errors.Date}
          />
        );
      case "Consumption Month":
        return (
          <MonthYearFilter
            title={"Consumption Month"}
            startMonth={tempFilter?.startMonth}
            endMonth={tempFilter?.endMonth}
            setStartMonth={(date) =>
              setTempFilter((prev) => ({ ...prev, startMonth: date }))
            }
            setEndMonth={(date) =>
              setTempFilter((prev) => ({ ...prev, endMonth: date }))
            }
            setErrors={setErrors}
            errors={errors.consumptionMonth}
          />
        );
      // case "Equipment":
      //   return (
      //     <MultiSelect
      //       title="Type of waste management"
      //       selectedFields={tempFilter}
      //       setSelectedFields={(updater) => {
      //         setTempFilter((prev) => {
      //           const newValue =
      //             typeof updater === "function" ? updater(prev) : updater;
      //           return {
      //             ...prev,
      //             equipment: newValue.equipment || newValue,
      //           };
      //         });
      //       }}
      //       errors={errors["Equipment"]}
      //       setErrors={setErrors}
      //       field="equipment"
      //       data={uniqueValues.equipment}
      //     />
      //   );

      case "Units Consumed (KWH)":
        return (
          <Range
            title="Units Consumed (KWH)"
            selectedRange={tempFilter.unitOfConsumption}
            setSelectedRange={(range) =>
              setTempFilter((prev) => ({
                ...prev,
                unitOfConsumption: range,
              }))
            }
            errors={errors["Units Consumed (KWH)"]}
            setErrors={setErrors}
            placeholderMax="Max(Units)"
            placeholderMin="Min(Units)"
          />
        );
      case "Current Reading":
        return (
          <Range
            title="Current Reading"
            selectedRange={tempFilter.currentMeterReading}
            setSelectedRange={(range) =>
              setTempFilter((prev) => ({
                ...prev,
                currentMeterReading: range,
              }))
            }
            errors={errors["Current Reading"]}
            setErrors={setErrors}
            placeholderMax="Max(KWH)"
            placeholderMin="Min(KWH)"
          />
        );

      case "Previous Reading":
        return (
          <Range
            title="Previous Reading"
            selectedRange={tempFilter.previousMeterReading}
            setSelectedRange={(range) =>
              setTempFilter((prev) => ({
                ...prev,
                previousMeterReading: range,
              }))
            }
            errors={errors["Previous Reading"]}
            setErrors={setErrors}
            placeholderMax="Max(KWH)"
            placeholderMin="Min(KWH)"
          />
        );
      default:
        return null;
    }
  };

  const fetchUniqueValues = async () => {
    try {
      const response = await get(
        `/scope2/consumptionByFacility/getAllConsumptionByFacility`
      );
      const data = response.data.data;

      // const uniqueEquipmentType = [
      //   ...new Set(
      //     data.map((el) => el.equipment?.equipment).filter(Boolean) // Filter out undefined values
      //   ),
      // ];
      const uniqueEquipmentType = [
        ...new Set(
          data
            .flatMap((el) => el.equipment?.map((equip) => equip.equipment))
            .filter(Boolean) // Flatten the equipment array and filter out undefined values
        ),
      ];
      const uniqueIndustrialEquipment = [
        ...new Set(
          data.map((el) => el?.currentMeterReading).filter(Boolean) // Filter out undefined values
        ),
      ];
      const uniqueUnit = [
        ...new Set(
          data.map((el) => el?.unitOfElectricityConsumption).filter(Boolean) // Filter out undefined values
        ),
      ];

      return {
        equipment: uniqueEquipmentType,
        // currentMeterReading: uniqueIndustrialEquipment,
        // unitOfElectricityConsumption: uniqueUnit,
      };
    } catch (error) {
      console.error("Error fetching unique values:", error);
      return {};
    }
  };

  const handleMenuClick = (event, data) => {
    setAnchorEl(event.currentTarget);
    // setSelectedPetroleum(item);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    // setSelectedPetroleum(null);
  };

  const handleEdit = (data) => {
    handleMenuClose();
    setAddData(true);
    setView(false);
    setdataView(data?._id !== undefined ? data : data?.data);
  };

  const handleView = (data) => {
    handleMenuClose();
    setView(true);
    setAddData(false);
    setdataForView(data?.data);
  };

  const handleDelete = (index) => {
    handleMenuClose();
    setDeleteDialog(true);
    setdataView(index.id);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // fetching petroleum data
  const fetchData = async (
    filters = isFiltersApplied ? filtersToApply : {}
  ) => {
    // const fetchData = async (filters = {}) => {
    try {
      const queryParams = new URLSearchParams({
        ...filters,
        page, // Add the current page
        limit: rowsPerPage, // Add the number of rows per page
        sortField: sortConfig.key, // Sort configuration
        sortOrder: sortConfig.direction,
      }).toString();
      const response = await get(
        `/scope2/consumptionByFacility/getAllConsumptionByFacility?${queryParams}`
      );
      let arr = response?.data?.data?.map((item) => {
        return {
          createdAt: new Date(item.createdAt).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          }),
          consumptionPeriod:
            new Date(
              item.consumptionPeriod.year, // Pass the year
              item.consumptionPeriod.month - 1
            ).toLocaleDateString("en-GB", {
              month: "short",
              // year: "numeric",
            }) +
            " " +
            item.consumptionPeriod.year,
          unitOfElectricityConsumption: item?.unitOfElectricityConsumption,
          currentMeterReading: item.currentMeterReading,
          previousMeterReading: item.previousMeterReading,
          equipment: item?.equipment,
          vendor: item.vendor?.VendorLegalFullName,
          action: "View",
          id: item?._id,
          data: item,
        };
      });
      setTableData(arr);
      fetchCardData(selectedMonth, selectedMonth);
      setPetroleums(response.data.data); // Update the user list
      setTotalPages(response.data.totalPages); // Update total pages for pagination
      const uniqueValues = await fetchUniqueValues();
      setUniqueValues(uniqueValues);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  useEffect(() => {
    fetchData(filtersToApply);
  }, [page, rowsPerPage, sortConfig]);

  const filtersToApply = {
    startDate: tempFilter?.startDate
      ? tempFilter?.startDate.format("YYYY-MM-DD")
      : "",
    endDate: tempFilter?.endDate
      ? tempFilter?.endDate.format("YYYY-MM-DD")
      : "",
    startMonth: tempFilter?.startMonth
      ? tempFilter?.startMonth.format("YYYY-MM-DD")
      : "",
    endMonth: tempFilter?.endMonth
      ? tempFilter?.endMonth.format("YYYY-MM-DD")
      : "",
    equipment: tempFilter?.equipment.join(","),

    ...(tempFilter.unitOfConsumption.min
      ? { minUnitConsumption: tempFilter.unitOfConsumption.min }
      : {}),
    ...(tempFilter.unitOfConsumption.max
      ? { maxUnitConsumption: tempFilter.unitOfConsumption.max }
      : {}),
    // Current Meter Reading
    ...(tempFilter.currentMeterReading.min
      ? { minCurrentMeterReading: tempFilter.currentMeterReading.min }
      : {}),
    ...(tempFilter.currentMeterReading.max
      ? { maxCurrentMeterReading: tempFilter.currentMeterReading.max }
      : {}),
    // Previous Meter Reading
    ...(tempFilter.previousMeterReading.min
      ? { minPreviousMeterReading: tempFilter.previousMeterReading.min } // Changed to minPrevious
      : {}),
    ...(tempFilter.previousMeterReading.max
      ? { maxPreviousMeterReading: tempFilter.previousMeterReading.max } // Changed to maxPreviousMeterReading
      : {}),
  };

  // function to validate filters
  // const validateFilters = () => {
  //   let isValid = true;
  //   const newErrors = {
  //     Date: false,
  //     "Previous Reading": false,
  //     "Current Reading": false,
  //     "Units Consumed": false,
  //     Equipment: false,
  //   };

  //   console.log(selectedFilter, "hi");

  //   if (selectedFilter === "Date") {
  //     const today = new Date(); // Get the current date

  //     // Ensure that startDate and endDate are not greater than today's date
  //     if (startDate && startDate > today) {
  //       newErrors.Date = "Start date cannot be in the future";
  //       isValid = false;
  //     }

  //     if (endDate && endDate > today) {
  //       newErrors.Date = "End date cannot be in the future";
  //       isValid = false;
  //     }

  //     // Ensure that the startDate is less than or equal to the endDate
  //     if (startDate && endDate && startDate > endDate) {
  //       newErrors.Date = "End date must be greater than Start date";
  //       isValid = false;
  //     }
  //   }
  //   if (selectedFilter === "Quantity Consumed") {
  //     const min = parseFloat(quantityRange.min);
  //     const max = parseFloat(quantityRange.max);

  //     if (min && isNaN(min)) {
  //       newErrors["Quantity Consumed"] =
  //         "Min consumption must be a valid number";
  //       isValid = false;
  //     }

  //     if (max && isNaN(max)) {
  //       newErrors["Quantity Consumed"] =
  //         "Max consumption must be a valid number";
  //       isValid = false;
  //     }

  //     if (!isNaN(min) && !isNaN(max) && min > max) {
  //       newErrors["Quantity Consumed"] =
  //         "Max value should be greater than Min value";
  //       isValid = false;
  //     }
  //   }

  //   if (selectedFilter === "Previous Reading") {
  //     const min = parseFloat(previousMeterReading.min);
  //     const max = parseFloat(previousMeterReading.max);
  //     console.log(min, max, "selected data");

  //     if (min && isNaN(min)) {
  //       newErrors["Previous Reading"] = "Min hours must be a valid number";
  //       isValid = false;
  //     }

  //     if (max && isNaN(max)) {
  //       newErrors["Previous Reading"] = "Max hours must be a valid number";
  //       isValid = false;
  //     }

  //     if (!isNaN(min) && !isNaN(max) && min > max) {
  //       newErrors["Previous Reading"] =
  //         "Min hours cannot be greater than max consumption";
  //       isValid = false;
  //     }
  //   }

  //   if (selectedFilter === "Current Reading") {
  //     const min = Number(currentMeterReading.min);
  //     const max = Number(currentMeterReading.max);

  //     if (min && isNaN(min)) {
  //       newErrors["Current Reading"] = "Min hours must be a valid number";
  //       isValid = false;
  //     }

  //     if (max && isNaN(max)) {
  //       newErrors["Current Reading"] = "Max hours must be a valid number";
  //       isValid = false;
  //     }

  //     if (!isNaN(min) && !isNaN(max) && min > max) {
  //       newErrors["Current Reading"] =
  //         "Min hours cannot be greater than max consumption";
  //       isValid = false;
  //     }
  //   }

  //   if (selectedFilter === "Units Consumed") {
  //     const min = parseFloat(unitOfConsumption.min);
  //     const max = parseFloat(unitOfConsumption.max);
  //     console.log(min, max, "selectedFiltersofUnit");

  //     if (min && isNaN(min)) {
  //       newErrors["Units Consumed"] =
  //         "Min hours must be a valid number";
  //       isValid = false;
  //     }

  //     if (max && isNaN(max)) {
  //       newErrors["Units Consumed"] =
  //         "Max hours must be a valid number";
  //       isValid = false;
  //     }

  //     if (!isNaN(min) && !isNaN(max) && min > max) {
  //       newErrors["Units Consumed"] =
  //         "Min hours cannot be greater than max consumption";
  //       isValid = false;
  //     }
  //   }

  //   // if (
  //   //   selectedFilter === "Equipment" &&
  //   //   selectedFields?.equipment?.length === 0
  //   // ) {
  //   //   newErrors["Equipment"] = "Please select atleast one Equipment";
  //   //   isValid = false;
  //   // }

  //   if (selectedFilter === "Hours Used") {
  //     const min = parseFloat(hoursRange.min);
  //     const max = parseFloat(hoursRange.max);

  //     if (!min && !max) {
  //       newErrors["Hours Used"] = "Please provide both min and max values";
  //       isValid = false;
  //     }

  //     if (min && isNaN(min)) {
  //       newErrors["Hours Used"] = "Min hours must be a valid number";
  //       isValid = false;
  //     }

  //     if (max && isNaN(max)) {
  //       newErrors["Hours Used"] = "Max hours must be a valid number";
  //       isValid = false;
  //     }

  //     if (!isNaN(min) && !isNaN(max) && min > max) {
  //       newErrors["Hours Used"] =
  //         "Min hours cannot be greater than max consumption";
  //       isValid = false;
  //     }
  //   }

  //   setErrors(newErrors);
  //   return isValid;
  // };
  // function to validate filters
  const validateFilters = () => {
    let isValid = true;
    const newErrors = {
      Date: false,
      "Previous Reading": false,
      "Current Reading": false,
      "Industrial Equipment": false,
      "Units Consumed": false,
      Equipment: false,
    };


    if (selectedFilter === "Date") {
      const today = new Date(); // Get the current date

      // Ensure that startDate and endDate are not greater than today's date
      if (startDate && startDate > today) {
        newErrors.Date = "Start date cannot be in the future";
        isValid = false;
      }

      if (endDate && endDate > today) {
        newErrors.Date = "End date cannot be in the future";
        isValid = false;
      }

      // Ensure that the startDate is less than or equal to the endDate
      if (startDate && endDate && startDate > endDate) {
        newErrors.Date = "End date must be greater than Start date";
        isValid = false;
      }
    }

    if (selectedFilter === "Consumption Month") {
      const today = new Date(); // Get the current date

      // Ensure that startMonth and endMonth are not greater than today's date
      if (startMonth && startMonth > today) {
        newErrors.Date = "Start Month cannot be in the future";
        isValid = false;
      }

      if (endMonth && endMonth > today) {
        newErrors.Date = "End Month cannot be in the future";
        isValid = false;
      }

      // Ensure that the startMonth is less than or equal to the endMonth
      if (startMonth && endMonth && startMonth > endMonth) {
        newErrors.Date = "End Month must be greater than Start Month";
        isValid = false;
      }
    }

    const validateRange = (range, fieldName) => {
      const min = parseFloat(range.min);
      const max = parseFloat(range.max);
      let error = "";

      // Check for numeric values
      if (range.min && isNaN(min)) {
        error = "Please enter a valid number";
        isValid = false;
      }
      if (range.max && isNaN(max)) {
        error = "Please enter a valid number";
        isValid = false;
      }

      // Check for negative values
      if (min < 0 || max < 0) {
        error = "Negative values are not allowed";
        isValid = false;
      }

      // Check min <= max
      if (!isNaN(min) && !isNaN(max)) {
        if (min > max) {
          error = "Minimum value cannot exceed maximum";
          isValid = false;
        }
      }

      if (error) {
        newErrors[fieldName] = error;
      }
    };

    // Validate based on selected filter
    switch (selectedFilter) {
      case "Previous Reading":
        validateRange(tempFilter.previousMeterReading, "Previous Reading");
        break;
      case "Current Reading":
        validateRange(tempFilter.currentMeterReading, "Current Reading");
        break;
      case "Units Consumed":
        validateRange(tempFilter.unitOfConsumption, "Units Consumed (KWH)");
        break;
      default:
        break;
    }

    if (selectedFilter === "Current Reading") {
      const min = Number(currentMeterReading.min);
      const max = Number(currentMeterReading.max);

      if (min && isNaN(min)) {
        newErrors["Current Reading"] = "Min hours must be a valid number";
        isValid = false;
      }

      if (max && isNaN(max)) {
        newErrors["Current Reading"] = "Max hours must be a valid number";
        isValid = false;
      }

      if (!isNaN(min) && !isNaN(max) && min > max) {
        newErrors["Current Reading"] =
          "Min hours cannot be greater than max consumption";
        isValid = false;
      }
    }

    if (selectedFilter === "Units Consumed (KWH)") {
      const min = parseFloat(unitOfConsumption.min);
      const max = parseFloat(unitOfConsumption.max);


      //   if ((min !== "" && min !== undefined && isNaN(Number(min))) ||
      //   (max !== "" && max !== undefined && isNaN(Number(max)))) {
      //     newErrors["Units Consumed (KWH)"] = "Please provide valid min and max values";
      //     isValid = false;
      // } else
      if (min < 0 || max < 0) {
        newErrors["Units Consumed (KWH)"] =
          "Min or Max values cannot be negative";
        isValid = false;
      } else if (min > max) {
        newErrors["Units Consumed (KWH)"] =
          "Min value cannot be greater than Max value";
        isValid = false;
      }
    }
    // if (
    //   selectedFilter === "Equipment" &&
    //   selectedFields?.equipment?.length === 0
    // ) {
    //   newErrors["Equipment"] = "Please select atleast one Equipment";
    //   isValid = false;
    // }

    if (selectedFilter === "Hours Used") {
      const min = parseFloat(hoursRange.min);
      const max = parseFloat(hoursRange.max);

      if (!min && !max) {
        newErrors["Hours Used"] = "Please provide both min and max values";
        isValid = false;
      }

      if (min && isNaN(min)) {
        newErrors["Hours Used"] = "Min hours must be a valid number";
        isValid = false;
      }

      if (max && isNaN(max)) {
        newErrors["Hours Used"] = "Max hours must be a valid number";
        isValid = false;
      }

      if (!isNaN(min) && !isNaN(max) && min > max) {
        newErrors["Hours Used"] =
          "Min hours cannot be greater than max consumption";
        isValid = false;
      }
    }

    setErrors(newErrors);
    return isValid;
  };

  // Applying selected filters
  const handleApplyFilters = () => {
    if (!validateFilters()) return;
    // Reset to first page when applying filters
    setStartDate(tempFilter.startDate);
    setEndDate(tempFilter.endDate);
    setStartMonth(tempFilter.startMonth);
    setEndMonth(tempFilter.endMonth);
    setSelectedFields({
      equipment: tempFilter.equipment,
    });
    setUnitOfConsumption(tempFilter.unitOfConsumption);
    setCurrentMeterReading(tempFilter.currentMeterReading);
    setPreviousMeterReading(tempFilter.previousMeterReading);

    setPage(1);
    fetchData(filtersToApply);
    setDrawerFilterOpen(false);
    handleAppliedFilters();
  };

  const handleResetFilters = async () => {
    setTempFilter({
      startDate: null,
      endDate: null,
      endMonth: null,
      startMonth: null,
      equipment: [],
      unitOfConsumption: { min: "", max: "" },
      previousMeterReading: { min: "", max: "" },
      currentMeterReading: { min: "", max: "" },
    });
    // Reset local state for date selection and selected fields
    setStartDate(null);
    setEndDate(null);
    setStartMonth(null);
    setEndMonth(null);
    setSelectedFields({
      equipment: [],
    });
    setPreviousMeterReading({ min: "", max: "" });
    setCurrentMeterReading({ min: "", max: "" });
    setUnitOfConsumption({ min: "", max: "" });

    // Call fetchData without any filters
    await fetchData({});
    setErrors({});
    setAppliedFilters({});
    setIsFiltersApplied(false);
    setDrawerFilterOpen(false);
  };
  const quarterMonths = {
    1: "Jan-Mar",
    2: "Apr-Jun",
    3: "Jul-Sep",
    4: "Oct-Dec",
  };
  const formatQuarterPeriod = (year, quarter) => {
    const months = quarterMonths[quarter] || "Unknown";
    return `${months}' ${year}`;
  };

  let bannerData = [
    {
      title: "Total Units Consumed",
      description: cardData?.totalConsumption
        ? formatNumber(cardData?.totalConsumption)
        : "N/A" || "N/A",
      unit: "KWH",
    },
    {
      title: "Peak Consumption Period",
      description: cardData?.peakData?.year
        ? formatQuarterPeriod(
            cardData?.peakData?.year || "N/A",
            cardData?.peakData?.quarter || "N/A"
          ) +
          " : " +
          formatNumberCommaSeparated(
            formatNumber(cardData?.peakConsumption ?? 0)
          ) +
          " KWH"
        : "N/A",
      unit: "KWH",
    },
    {
      title: "Consumption Month",
      description: cardData?.monthly ? formatNumber(cardData?.monthly) : "N/A",
      unit: "KWH",
      filter: "date",
    },
  ];

  const handleFilterChangeCards = (filterValue) => {

    // if (type === "date") {
    const [year, month] = filterValue.split("-");
    setFilters((prev) => ({
      ...prev,
      month,
      year,
    }));

    fetchCardData(year, month, "");
  };

  const fetchCardData = async (year, month) => {
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth();
    try {
      const response = await get(`/scope2/consumptionByFacility/cardData`, {
        params: {
          // year, month,
          year: selectedYear ? selectedYear : currentYear,
          month: selectedMonth ? selectedMonth : currentMonth + 1,
          //  equipment: equipment
        },
      });
      if (response) {
        setCardData({
          ...cardData,
          monthly:
            response.data.data.monthly.length > 0 &&
            response.data.data.monthly.map((item) => item.totalConsumption),
          totalConsumption: response.data.data.total.map(
            (item) => item.totalConsumption
          ),
          peakConsumption: response.data.data.peakData.peakConsumption,
          peakData: response.data.data.peakData,
          // peakConsumption: response.data.data.peakData?.peakConsumption,
        });
      }
    } catch (error) {
      console.error("Error fetching card data:", error);
    }
  };

  useEffect(() => {
    fetchCardData(selectedYear, selectedMonth);
  }, [selectedMonth, selectedYear]);

  const handleAppliedFilters = () => {
    const isDateApplied = tempFilter?.startDate || tempFilter?.endDate;
    const isConsumptionMonth = tempFilter?.startMonth || tempFilter?.endMonth;
    const isEquipmentTypeApplied = selectedFields.vendor?.length > 0;
    // const isEquipmentApplied = selectedFields.equipment?.length > 0;
    const isEquipmentApplied = tempFilter?.equipment?.length > 0;

    const isUnitRangeApplied =
      tempFilter.unitOfConsumption.min || tempFilter.unitOfConsumption.max;

    const isCurrentReadingRangeApplied =
      tempFilter.currentMeterReading.min || tempFilter.currentMeterReading.max;

    const isUnitOfConsumptionApplied =
      tempFilter.previousMeterReading.min ||
      tempFilter.previousMeterReading.max;

    setIsFiltersApplied(
      isDateApplied ||
        isConsumptionMonth ||
        isEquipmentTypeApplied ||
        isUnitRangeApplied ||
        isEquipmentApplied ||
        isUnitOfConsumptionApplied ||
        isCurrentReadingRangeApplied
    );

    setAppliedFilters((prevAppliedFilters) => ({
      ...prevAppliedFilters,
      Date: isDateApplied,
      "Consumption Month": isConsumptionMonth,
      Equipment: isEquipmentApplied,
      "Units Consumed (KWH)": isUnitRangeApplied,
      "Previous Reading": isUnitOfConsumptionApplied,
      "Current Reading": isCurrentReadingRangeApplied,
    }));
  };

  // Handle Sorting function
  const handleSort = (column, direction) => {
    setSortConfig({ key: column, direction });
  };
  const uploadErrorClose = () => {
    setBulkUploadTable(true);
  };
  const handleFilterDrawer = () => {
    setTempFilter({
      startDate: startDate,
      endDate: endDate,
      startMonth: startMonth,
      endMonth: endMonth,
      equipment: selectedFields.equipment,
      unitOfConsumption: {
        min: unitOfConsumption.min,
        max: unitOfConsumption.max,
      },
      previousMeterReading: {
        min: previousMeterReading.min,
        max: previousMeterReading.max,
      },
      currentMeterReading: {
        min: currentMeterReading.min,
        max: currentMeterReading.max,
      },
    });
    setDrawerFilterOpen(false);
  };

  const handleCloseBulkUpload = () => {
    setBulkUploadModal(false);
    fetchData();
  };

  const handleOpenFilterDrawer = () => {
    setTempFilter({
      startDate: startDate,
      endDate: endDate,
      startMonth: startMonth,
      endMonth: endMonth,
      equipment: selectedFields.equipment,
      unitOfConsumption: tempFilter.unitOfConsumption,
      previousMeterReading: tempFilter.previousMeterReading,
      currentMeterReading: tempFilter.currentMeterReading,
    });
    setDrawerFilterOpen(true);
  };

  return (
    <Box
      sx={{
        backgroundColor: "#ededed",
      }}
    >
      <Snackbar
        open={snackOpen.open}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={() => setsnackOpen({ ...snackOpen, open: false })}
      >
        <Alert
          severity={snackOpen.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackOpen.message}
        </Alert>
      </Snackbar>

      <AddConsumptionByFacility
        addData={addData}
        id={dataView ? dataView._id : ""}
        setAddData={setAddData}
        SelectedData={dataView}
        fetchData={fetchData}
        inputData={inputData}
        addUrl={`${api}/scope2/consumptionByFacility/addConsumptionByFacility`}
        updateUrl={`${api}/scope2/consumptionByFacility/updateConsumptionByFacility`}
        setsnackOpen={setsnackOpen}
      />
      <ViewConsumptionByFacility
        view={view}
        setView={setView}
        selectedData={dataforView}
        handleEdit={handleEdit}
        companyAdmin={user?.companyAdmin}
      />

      <Cards
        data={bannerData}
        title={"Electricity  "}
        onFilterChange={handleFilterChangeCards}
        {...{ setSelectedMonth, setSelectedYear, selectedMonth, selectedYear }}
      />
      {deleteDialog && (
        <DeleteAlertDialog
          {...{
            deleteDialog,
            setDeleteDialog,
            method: "delete",
            id: dataView,
            url: `${api}/scope2/consumptionByFacility/deleteConsumptionByFacility`,
            setsnackOpen,
            fetchData,
            fetchCardData,
          }}
        />
      )}

      {/* <Toolbar sx={{ padding: "0 16px", marginBottom: "20px" }}> */}
      <Box>
        {drawerFilterOpen && (
          <FilterDrawer
            {...{
              renderSelectedFilter,
              drawerFilterOpen,
              setDrawerFilterOpen,
              handleApplyFilters,
              handleFilterDrawer,
              setSelectedFilter,
              handleResetFilters,
              selectedFilter,
              filters,
              appliedFilters,
              selectedFields,
              setSelectedFields,
            }}
          />
        )}{" "}
        {/* Top Box for Heading, Filter Button, Add Data Button */}
        <TopMenuUpload
          setData={setdataView}
          setAddData={setAddData}
          {...{
            // heading: "Coal",
            setBulkUploadModal,
            setDrawerFilterOpen: handleOpenFilterDrawer,
            filterApplied: isFiltersApplied,
          }}
        />
        {/* </Toolbar> */}
      </Box>
      <ViewTable
        headers={headers}
        title={"Consumption By Facility"}
        data={tableData}
        onSort={handleSort}
        sortConfig={sortConfig}
        onMenuClick={handleMenuClick}
        page={2}
        editIcon={user?.companyAdmin ? "disable" : "enable"}
        count={10}
        onPageChange={() => {
          // console.log("first");
        }}
        onView={handleView}
        onEdit={handleEdit}
        onDelete={handleDelete}
      />
      {totalPages > 1 && (
        <PaginationBox
          {...{ totalPages, page, handleChangePage, StyledPaginationItem }}
        />
      )}
      {/* Menu for Actions */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        PaperProps={{
          sx: {
            width: "120px",
            border: "1px solid #ddd",
            marginLeft: "-47px",
          },
        }}
      >
        <MenuItem onClick={handleView} sx={{ fontSize: "14px" }}>
          <AssignmentIcon sx={{ marginRight: "8px", fontSize: "large" }} /> View
          Logs
        </MenuItem>
        <MenuItem onClick={handleEdit} sx={{ fontSize: "14px" }}>
          <EditIcon sx={{ marginRight: "8px", fontSize: "large" }} /> Edit
        </MenuItem>

        <MenuItem onClick={handleDelete} sx={{ fontSize: "14px" }}>
          <DeleteIcon sx={{ marginRight: "8px", fontSize: "large" }} /> Delete
        </MenuItem>
      </Menu>

      {bulkUploadModal && (
        <BulkUploadModal
          onCloseBulkUpload={handleCloseBulkUpload}
          isBulkUploadModal={bulkUploadModal}
          setsnackOpen={setsnackOpen}
          excelData={excelData}
          setBulkUploadModal={setBulkUploadModal}
          formDataBulkUpload={formDataBulkUpload}
          setFormDataBulkUpload={setFormDataBulkUpload}
          setBulkUploadTable={setBulkUploadTable}
          setMatchData={setMatchData}
          matchedKey={"statusList"}
          errorClose={uploadErrorClose}
          fileName={"Electricity Facility"}
          url={"/scope2/consumptionByFacility/electricity/bulkupload"}
          setJsonBulkUpload={setJsonBulkUpload}
        />
      )}
      {bulkUploadTable && (
        <BulkUpload
          matchData={matchData}
          setMatchData={setMatchData}
          onClose={() => setBulkUploadTable(false)}
          bulkUploadTable={bulkUploadTable}
          formData={formDataBulkUpload}
          setFormData={setFormDataBulkUpload}
          setFormDatas={setFormData}
          formDatas={formData}
          title1="Equipment Name"
          keyValue1="equipment"
          title2="Vendor Name"
          keyValue2="vendor"
          vendorURl={`/master/electricity/creatVendor`}
          EquipmentURl={`/master/Electricity/creatEquipment`}
          bulkUploadUrl={"/scope2/consumptionByFacility/electricity/jsonUpload"}
          options1={equipmentData}
          setVendorData={setVendorData}
          setEquipmentData={setEquipmentData}
          jsonBulkUpload={jsonBulkUpload}
          options2={vendorData}
          matched1={"equipmentMatched"}
          matched2={"vendorMatched"}
          setsnackOpen={setsnackOpen}
          onConfirm={() => {
            setBulkUploadTable(false);
            fetchData();
          }}
        />
      )}
    </Box>
  );
};

export default ElectricityConsumption;
